//en.js

import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  message: {
    'veS_overall_s_pl': 'please enter the keyword',
  },
  ...enLocale
}

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js